import VueFormulate from '@braid/vue-formulate'
import SelectInputResourceful from '@/components/formulate/SelectInputResourceful'
import SelectInputResourcefulV2 from '@/components/formulate/SelectInputResourcefulV2'
import TextInput from '@/components/formulate/TextInput'
import CustomDatePicker from '@/components/formulate/CustomDatePicker'
import GroupInput from '@/components/formulate/GroupInput'
import ValueHelpInputV2 from '@/components/formulate/ValueHelpInputV2'
// NOTE:
// This plugins requires these dependencies:
// - Vue Bootstrap
// - Datepicker
// So it should be called after those dependencies are registered
// we can re-import and register them here but need to check will it increase
// the bundle size

export default {
  install(Vue) {
    // register your component with Vue
    Vue.component('SelectInputResourceful', SelectInputResourceful)
    Vue.component('SelectInputResourcefulV2', SelectInputResourcefulV2)
    Vue.component('TextInput', TextInput)
    Vue.component('CustomDatePicker', CustomDatePicker)
    Vue.component('GroupInput', GroupInput)
    Vue.component('ValueHelpInputV2', ValueHelpInputV2)

    Vue.use(VueFormulate, {
      // Adds tooltips, etc. to the input labels
      // More info https://vueformulate.com/guide/inputs/slots/#slot-components

      slotProps: {
        help: ['size'],
      },

      // Custom inputs
      library: {
        // Overrides text input to implement masking functionality
        text: {
          classification: 'text',
          component: 'TextInput',
          slotProps: {
            component: ['size'],
          },
        },
        // TODO: can be renamed to 'select' instead of 'multiselect'
        // since 'select' can cover 'multi' or 'single'
        'select-resourceful': {
          classification: 'search',
          component: 'SelectInputResourceful',
          slotProps: {
            component: [
              'initialObject',
              'trackBy',
              'optionLabelFn',
              'optionsGetter',
              'multiple',
              'size',
              'overrideFilters',
            ],
          },
        },
        'select-resourceful-v2': {
          classification: 'search',
          component: 'SelectInputResourcefulV2',
          slotProps: {
            component: [
              'fullObject',
              'trackBy',
              'optionLabelFn',
              'optionsGetter',
              'multiple',
              'size',
              'hasImage',
              'tagCustom',
              'taggable',
              'hasDelete',
            ],
          },
        },
        'value-help-v2': {
          classification: 'search',
          component: 'ValueHelpInputV2',
          slotProps: {
            component: [
              'fullObject',
              'size',
              'disabled',
              'multiple',
              'displayedBy',
              'multiple',
              'canBeNull',
              'identifier',
            ],
          },
        },
        'date-picker': {
          classification: 'text',
          component: 'CustomDatePicker',
          slotProps: {
            component: ['size', 'datepickerType', 'shortcuts', 'pickDate', 'disabledDate'],
          },
        },
        'group-input': {
          classification: 'text',
          component: 'GroupInput',
          slotProps: {
            component: ['size', 'prepend', 'append'],
          },
        },
      },

      // Custom validation rules
      rules: {
        isUnique: ({ value }, args) => {
          const data = args.map((obj) => {
            return obj['name'] ? obj['name'].toLowerCase() : obj['action'].toLowerCase()
          })
          const validate = data.includes(value.toLowerCase())
          if (validate === true) return false
          return true
        },

        time: ({ value }) => {
          const regex = /^([01]\d|2[0-3]):([0-5]\d)$/
          return regex.test(value)
        },

        phone: ({ value }) => {
          const regex = /^(?:0|62)8[1-9][0-9]{7,10}$/
          return regex.test(value)
        },
        hostname: ({ value }) => /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/.test(value)
      },

      // Custom validation messages per rules
      locales: {
        en: {
          required: () => `Wajib Terisi`,
          number: ({ name }) => `${name} harus berupa angka`,
          email: ({ name }) => `${name} harus dalam format yang sesuai`,
          not: ({ args, name }) => `${name} tidak boleh ${args[0]}`,
          max: ({ args, name }) => {
            const [max, type] = args
            if (type === 'value') return `${name} tidak lebih dari ${(+max).toLocaleString()}`
            return `${name} tidak lebih dari ${(+max).toLocaleString()} karakter`
          },
          min: ({ args, name }) => {
            const [min, type] = args
            if (type === 'value') return `${name} tidak kurang dari ${(+min).toLocaleString()}`
            return `${name} tidak kurang dari ${(+min).toLocaleString()} karakter`
          },
          isUnique: () => `Input Tidak Boleh Duplikat`,
          time: ({ args, name }) => {
            return `${name} harus dalam format ${args}`
          },
          phone: () =>
            'Format nomor tidak valid. Pastikan dimulai dengan 08 atau 628 dan memiliki 10–13 digit.',
        },
      },

      // Value to be shown in the error message
      // check for validation-name props first, then label, then the rest
      // https://vueformulate.com/guide/validation/#customize-validation-messages
      validationNameStrategy: ['validationName', 'label', 'name', 'type'],
    })
  },
}
